const AppConfig = {
	msClientId: '88704920-3119-473b-b5f4-219639c48419',
	apiServiceBaseUri: 'http://localhost:30641/'
};

export default AppConfig;


// WEBPACK FOOTER //
// ./CarsNowAppConfig.js